import {
  DEFAULT_WORKER_MEMORY_MB,
  DEFAULT_WORKER_TIMEOUT_SECONDS,
  type WorkerVersionComputeConfigType,
} from "@validereinc/domain";

export type ResolvedWorkerVersionComputeConfigType = {
  timeoutSeconds: number;
  memoryMb: number;
};

export const resolveWorkerVersionComputeConfig = (
  computeConfig: WorkerVersionComputeConfigType
): ResolvedWorkerVersionComputeConfigType => ({
  timeoutSeconds:
    computeConfig.timeout_seconds ?? DEFAULT_WORKER_TIMEOUT_SECONDS,
  memoryMb: computeConfig.memory_mb ?? DEFAULT_WORKER_MEMORY_MB,
});
